import {t} from '@lingui/macro'

import yup from '@product-web/validation/yup'

export const validationSchema = yup.object().shape({
    email: yup
        .string()
        .required(() => t`Please enter your email address.`)
        .email(() => t`This email doesn't look right, please check for typos`),
})

export type FormValues = {
    email: string
}
